import React from 'react'

export class HiddenSprintPayButton extends React.Component {

  constructor(props) {
    super(props)
    this.buttonClass = 'with-sprintpay__button'
    this.scriptId = 'SP-SCRIPT'
  }

  componentDidMount() {
    const script = document.createElement("script")
    script.id = this.scriptId
    script.src = "https://cargosprint-popup-stg.firebaseapp.com/assets/scripts/with-sprintpay.js"
    script.async = true
    script.onload = () => {
      const elements = document.getElementsByClassName(this.buttonClass)
      if (elements.length) {
        elements[0].click()
      }
    }
    document.body.appendChild(script)
  }

  render() {
    const amountWithoutComma = this.props.amount.replaceAll(",", "")
    return (
        // note that attribute names must be all lowercase for React to pass them on to the DOM
        <button
            key={this.props.paymentReqNo}
            style={{display: 'none'}}
            className={this.buttonClass}
            environment={this.props.env === 'PRD' ? 'production' : 'staging'}
            callbackurl={window.location.protocol.concat("//", window.location.host,
                '/openapis/sprintPay/complete')}
            amount={amountWithoutComma}
            awb={this.props.paymentReqNo}
            facility="4004"
            customerreference={this.props.customerRef}
            hawb=""
            notes={this.props.notes}
            notificationemail={this.props.notifyEmail}
            paidto="OOCL"
            paymenttype="Demurrage"
        />
    )
  }

  componentWillUnmount() {
    const element = document.getElementById(this.scriptId)
    if (element) {
      document.body.removeChild(element)
    }
  }
}

export default HiddenSprintPayButton